import { PoolModelData, CreatePool } from "../model/approvalPoolModel";

export type JobApprovalPoolAction =
  | { type: "SET_POOL_FORM_DATA"; payload: Partial<CreatePool> }
  | { type: "SET_POOLS"; payload: PoolModelData[] }
  | { type: "SET_ERROR"; payload: string | null }
  | { type: "SET_USERS"; payload: any[] }
  | {
      type: "UPDATE_POOL_FORM_FIELD";
      payload: { field: keyof CreatePool; value: any };
    }
  | { type: "SET_SHOW_MODAL"; payload: boolean }
  | {
      type: "SET_TOAST";
      payload: {
        isVisible: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
      };
    }
  | { type: "OPEN_DELETE_DIALOG"; payload: string }
  | {
      type: "RESET_POOL_FORM";
      payload: string;
    }
  | { type: "CLOSE_DELETE_DIALOG" }
  | { type: "HIDE_TOAST" }
  | { type: "SET_LIST_LOADING"; payload: boolean }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_EDITING_POOL"; payload: PoolModelData | undefined }
  | { type: "CLOSE_POOL_DIALOG" }
  | { type: "SET_POOL_MODE"; payload: "create" | "edit" | "view" }
  | { type: "SET_POOL_DIALOG_OPEN"; payload: boolean };

export const setPoolFormData = (
  payload: Partial<CreatePool>,
): JobApprovalPoolAction => ({
  type: "SET_POOL_FORM_DATA",
  payload,
});
export const setPools = (payload: any[]): JobApprovalPoolAction => ({
  type: "SET_POOLS",
  payload,
});
export const setLoading = (payload: boolean): JobApprovalPoolAction => ({
  type: "SET_LOADING",
  payload,
});
export const updateFormField = (
  field: keyof CreatePool,
  value: any,
): JobApprovalPoolAction => ({
  type: "UPDATE_POOL_FORM_FIELD",
  payload: { field, value },
});
export const setError = (payload: string | null): JobApprovalPoolAction => ({
  type: "SET_ERROR",
  payload,
});
export const setUsersManagement = (payload: any[]): JobApprovalPoolAction => ({
  type: "SET_USERS",
  payload,
});
export const setShowModal = (payload: boolean): JobApprovalPoolAction => ({
  type: "SET_SHOW_MODAL",
  payload,
});
export const setToast = (payload: {
  isVisible: boolean;
  message: string;
  type: "success" | "error" | "warning" | "info";
}): JobApprovalPoolAction => ({
  type: "SET_TOAST",
  payload,
});

export const hideToast = (): JobApprovalPoolAction => ({
  type: "HIDE_TOAST",
});
export const resetPoolForm = (): JobApprovalPoolAction => ({
  type: "RESET_POOL_FORM",
  payload: "",
});
